<div class="mobile-only-container">
  <div class="content">
    <mat-icon class="device-icon">smartphone</mat-icon>

    <h1>Acceso Exclusivo para Celulares</h1>

    <p class="description">
      Para garantizarte la mejor experiencia, nuestro menú digital está diseñado exclusivamente para dispositivos
      móviles.
    </p>

    <div class="instruction-box">
      <mat-icon class="qr-icon">qr_code_scanner</mat-icon>
      <p><strong>Por favor, escanea el código QR de tu mesa con la cámara de tu celular para comenzar.</strong></p>
    </div>
  </div>
</div>
¡
